import React, { useState } from "react";
import Loading from "../../common/Loading";
import UserList from "./UserList";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchUsers,
  getUsers,
  getUsersRole,
  getUsersStatus,
} from "../../../redux/slice/usersSlice";
import UpperSection from "../common/UpperSection";

const AdminMain = () => {
  const dispatch = useDispatch();
  const [searchQuery, setSearchQuery] = useState("");

  const users = useSelector(getUsers);
  const status = useSelector(getUsersStatus);

  const selectedRole = useSelector(getUsersRole);

  const [role, setRole] = useState(selectedRole);

  const handleRoleChange = (e) => {
    setRole(e.target.value);
    dispatch(fetchUsers(e.target.value));
  };

  const filterdUsers = users?.filter((user) => {
    return user?.name?.toLowerCase().includes(searchQuery);
  });

  return (
    <section className="flex flex-col gap-12 w-full">
      {status === "loading" ? <Loading /> : null}
      {/* Upper Section */}
      <UpperSection
        title="Users"
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
      />

      {/* Lower section */}
      <section className="bg-primary flex flex-col gap-10 w-full sm:p-7 p-3 rounded-[4px] border border-adminMainBorder">
        {/* Upper Section */}
        <div className="flex flex-row w-full justify-between items-center">
          <span className="text-textPrimary text-[18px] font-semibold">
            Users List
          </span>
          <div className="flex flex-row gap-6">
            <div className="">
              <select
                name="role"
                id="role"
                value={role}
                onChange={handleRoleChange}
                className="h-[32px] border text-sm px-4 rounded-[4px] border-textSecondary focus:outline-none text-textSecondary w-full"
              >
                <option value="CLIENT">Client</option>
                <option value="ADMIN">Admin</option>
              </select>
            </div>
          </div>
        </div>
        {status === "success" ? <UserList filterdUsers={filterdUsers} /> : null}
      </section>
    </section>
  );
};

export default AdminMain;
